<template>

    <el-select :size="size"
               :value="value"
               :multiple="multiple"
               :collapse-tags="collapse"
               :filterable="filterable"
               :disabled="disabled"
               :clearable="clearable"
               @clear="sysroomClear"
               @change="change($event)">
        <el-option v-for="item in sysroomListNew" :label="item.name" :value="item.id"
                   :key="item.id"></el-option>
    </el-select>

</template>


<script>

    import { createNamespacedHelpers } from 'vuex';

    const sysroomNSHelper = createNamespacedHelpers( "sysroomNew" );

    export default {

        name: 'deptSelect',

        props: ['value', 'multiple', 'filterable', 'clearable', 'disabled', 'size', 'collapse', 'filterDcIds'],

        data() {
            return {
                sysroomListNew: [],
            }
        },

        mounted() {

            this.getSysroomSourceNew();

            let that = this;
            this.sysroomSourceNew$.subscribe(v => {
                if(this.filterDcIds && this.filterDcIds.length > 0) {
                    that.sysroomListNew = v.data.filter(item => this.filterDcIds.includes(String(item.id)));
                } else {
                    that.sysroomListNew = v.data;
                }
                this.$emit('fetchAllSysrooms', that.sysroomListNew);
            });

        },

        methods: {

            ...sysroomNSHelper.mapActions(['getSysroomSourceNew']),

            change: function (keys) {
                this.$emit('input', keys);
            },
            sysroomClear(){
                this.$emit('sysroomClear', null);
            }

        },

        computed: {
            ...sysroomNSHelper.mapGetters(['sysroomSourceNew$']),
        },


    }

</script>